/**
 * Validates CSV data structure consistency
 * @param csvToValidate The CSV string to validate
 * @returns true if the string is:
 * - Non-empty
 * - Contains at least one row
 * - All rows have the same number of columns (consistent structure)
 * - Handles trailing empty lines gracefully
 * @returns false for empty strings, inconsistent column counts, or parsing errors
 */
export const validateCsvStructure = (csvToValidate: string) => {
  try {
    if (!csvToValidate || csvToValidate.trim() === '') {
      return false
    }

    const rows = csvToValidate.split('\n')

    if (rows.length === 0) return false

    // Check that all rows have the same number of columns
    const firstRowColumns = rows[0].split(',').length

    return rows.every((row, index) => {
      // Skip empty last line
      if (index === rows.length - 1 && row.trim() === '') {
        return true
      }
      return row.split(',').length === firstRowColumns
    })
  } catch (error) {
    return false
  }
}
